import request from '@/utils/service'

// 套餐卡订单列表
export function packageOrderListApi(data) {
  return request({
    url: '/monthCardOrder/listNew',
    method: 'get',
    params: data
  })
}

// 套餐卡订单详情
export function packageOrderDetailApi(data) {
  return request({
    url: '/monthCardOrder/detailNew',
    method: 'get',
    params: data
  })
}

// 套餐卡订单分成
export function packageOrderDivvyListApi(code) {
  return request({
    url: `/monthCardOrder/divide/${code}`,
    method: 'get'
  })
}

// 套餐卡订单分成
export function packageCardRefundApi(data) {
  return request({
    url: '/monthCardOrder/packageCardRefund',
    method: 'post',
    data
  })
}
